export const MISSING_VALUES = ["", "NA", null, undefined];

export const DEFAULT_COLUMNS = ["LSR #", "Study identifier", "Study Arm"];

export function getAllVariablesFor(node) {
  const variables = new Set(node.variables || []);

  if (node.children) {
    node.children.forEach((child) => {
      getAllVariablesFor(child).forEach((variable) => variables.add(variable));
    });
  }

  return Array.from(variables);
}

export function sortNodes(a, b) {
  const aHasChildren = a.children.length > 0;
  const bHasChildren = b.children.length > 0;

  if (aHasChildren !== bHasChildren) {
    return bHasChildren - aHasChildren; // True (1) moves b up, false (-1) moves a up
  }

  const aLabel = a.label.trim().toLowerCase();
  const bLabel = b.label.trim().toLowerCase();

  return aLabel.localeCompare(bLabel);
}

export function getNodeClasses(ontologyDictionary, keys) {
  return keys.reduce((classes, key) => {
    const ontologyClass = ontologyDictionary[key];
    if (ontologyClass) {
      classes.push({
        id: key,
        label: ontologyClass.label,
        formal_label: ontologyClass.formal_label,
        definition: ontologyClass.definition
      });
    }
    return classes;
  }, []);
}

export function getNodeLabel(ontologyDictionary, node, nodeClasses) {
  return ontologyDictionary[node.key]?.label
    ?? (nodeClasses.length > 1 ? nodeClasses.map(cls => cls.label).join(" - ") : node.key);
}
